export default {
  base: {
    border: '1px solid',
    borderRadius: '100px',
    fontFamily: 'base',
    fontSize: 'xxs',
    fontWeight: 'base',
    lineHeight: '22px',
    p: '1px',
    display: 'inline-block',
    bg: 'grey-0',
    color: 'grey-100',
    borderColor: 'grey-30',
    variant: 'spark.base.wrapper',
    close: {
      display: 'inline-block',
      p: 0,
      border: 'none',
      color: 'unset',
      backgroundColor: 'transparent',
      appearance: 'none',
      ml: '1px',
      mr: '7px',
      verticalAlign: 'middle',
      disabled: {
        color: 'grey-60'
      }
    },
    focus: {
      bg: 'secondary',
      color: 'deepBlue',
      borderColor: 'secondary',
      outline: 'none'
    },
    hover: {
      bg: 'grey-100',
      color: 'grey-0',
      borderColor: 'grey-100'
    },
    active: {
      p: '0px',
      bg: 'grey-0',
      color: 'grey-100',
      borderColor: 'grey-100',
      borderWidth: '2px'
    },
    disabled: {
      p: '1px',
      bg: 'grey-10',
      color: 'grey-60',
      borderColor: 'grey-10',
      borderWidth: '1px'
    }
  },
  variants: {
    disabled: {
      variant: 'spark.element.tag.base',
      p: '1px',
      bg: 'grey-10',
      color: 'grey-60',
      borderColor: 'grey-10',
      borderWidth: '1px',
      close: {
        variant: 'spark.element.tag.base.close',
        disabled: {
          variant: 'spark.element.tag.base.close.disabled'
        }
      }
    }
  }
};